export default {
  category: 'book',
  name: 'The Go-Giver',
  author: 'Bob Burg',
  date: '5/27/22',
  path: '/notes/the-go-giver',
  photo: 'https://twos.s3.amazonaws.com/parkerklein/parker-klein-the-go-giver-bob-burg.jpg',
  tags: ['Business', 'Money', 'Sales'],
  time: 3,
  rating: 7.7,
  review: '',
  link: 'https://www.amazon.com/Go-Giver-Expanded-Little-Powerful-Business/dp/1591848288',
  mediumLink: 'https://medium.com/twosapp/the-go-giver-by-bob-burg-and-john-david-mann-b3079e601217',
  patreonLink: '',
  // podcastLink: 'https://anchor.fm/parkerklein/episodes/',
  // podcastEmbed: 'https://anchor.fm/parkerklein/embed/episodes/',
  // youtubeLink: 'https://youtu.be/',
twosLink: 'https://www.TwosApp.com/628adc39fe37f3e5a0f56ac0',
  // youtubeEmbed: 'https://www.youtube.com/embed/',
  releaseDate: '',
};
